import { gql } from '@apollo/client';

// TODO: Split to Fragments
export const GET_ONBOARDING_QUESTIONS_ANSWERS = gql`
  query {
    onboardingQuestionsWithAnswers {
      onboarding_questions {
        questions {
          category
          header
          key
          selectOption
          subheader
          tooltip {
            body
            title
          }
          assistiveText {
            anchor {
              title
            }
            content {
              title
              body {
                text
                interpolations {
                  key
                  url
                  text
                }
              }
            }
            cta
          }
          answers {
            androidIcon
            followUpQuestionKey
            iosIcon
            key
            subtitle
            title
            webIcon
          }
        }
        followUpQuestions {
          answers {
            webIcon
            title
            subtitle
            key
            iosIcon
            followUpQuestionKey
            androidIcon
          }
          category
          header
          key
          selectOption
          subheader
        }
      }
      onboarding_questions_answers {
        questions {
          children_under_eighteen {
            answers
          }
          debt_estimate {
            answers
          }
          employment_status {
            answers
          }
          filing_status {
            answers
          }
          financial_profile_question_1 {
            answers
          }
          financial_profile_question_2 {
            answers
          }
          financial_profile_question_3 {
            answers
          }
          financial_profile_question_4 {
            answers
          }
          have_a_retirement_account {
            answers
          }
          household_income_bracket {
            answers
          }
          how_do_you_want_to_use_stash {
            answers
          }
          investing_experience {
            answers
          }
          pay_frequency {
            answers
          }
          risk_tolerance {
            answers
          }
          time_horizon {
            answers
          }
          total_net_worth_range {
            answers
          }
        }
      }
    }
  }
`;
